export const mr = {
  header: {
    brandSubtitle: "करिअर पोर्टल",
    openings: "रिक्त पदे",
    howToApply: "अर्ज कसा करावा",
    lifeAtMMMOCL: "एमएमएमओसीएल मधील जीवन",
    notices: "सूचना",
    help: "मदत",
    signIn: "लॉगिन",
    register: "नोंदणी करा",
    signedInAs: "लॉगिन केलेले:",
    myProfile: "माझे प्रोफाईल",
    logout: "लॉगआउट",
  },
  footer: {
    title: "महा मुंबई मेट्रो ऑपरेशन कॉर्पोरेशन मर्यादित",
    copyright: "एमएमएमओसीएल. महाराष्ट्र शासनाचा उपक्रम.",
    privacy: "गोपनीयता धोरण",
    terms: "नियम व अटी",
    accessibility: "सुलभता",
    rti: "माहिती अधिकार",
    contact: "संपर्क",
  },
  home: {
    heroBadge: "महा मुंबई मेट्रो भरती",
    heroTitle: "मुंबईची जीवनवाहिनी घडवा",
    heroSubtitle:
      "मुंबई महानगर प्रदेशातील कोट्यवधी नागरिकांसाठी आधुनिक, सुरक्षित आणि शाश्वत मेट्रो सेवा पुरवणाऱ्या समर्पित पथकात सहभागी व्हा.",
    exploreOpenings: "रिक्त पदे पहा",
    howItWorks: "अर्ज प्रक्रिया",
    activeHiringBadge: "ऑपरेशन्स, अभियांत्रिकी व प्रशासकीय विभागांमध्ये भरती सुरू",

    searchPlaceholder: "पदाचे नाव, भूमिका किंवा कीवर्डने शोधा...",
    allDepartments: "सर्व विभाग",
    anyType: "सर्व प्रकार",
    allLocations: "सर्व ठिकाणे",
    searchBtn: "शोधा",
    resetFilters: "फिल्टर रीसेट करा",
    showingResults: "{count} रिक्त पदे उपलब्ध",

    statOpenings: "उपलब्ध रिक्त पदे",
    statLines: "मेट्रो मार्गिका",
    statApplicants: "नोंदणीकृत उमेदवार",
    statGrowth: "विस्तारित मार्गिका",

    whyJoinTitle: "एमएमएमओसीएल मध्ये करिअर का निवडावे?",
    whyJoinSubtitle:
      "महाराष्ट्राच्या आघाडीच्या मेट्रो संस्थेचा भाग व्हा आणि सार्वजनिक वाहतुकीला नवी दिशा द्या.",
    benefit1Title: "आकर्षक वेतन व भत्ते",
    benefit1Desc:
      "शासकीय वेतनश्रेणी, महागाई भत्ता, घरभाडे भत्ता, वैद्यकीय विमा आणि मेट्रो प्रवास सवलत.",
    benefit2Title: "नोकरीची सुरक्षितता",
    benefit2Desc:
      "दीर्घकालीन सुरक्षितता, भविष्य निर्वाह निधी (PF), उपदान (Gratuity) आणि कुटुंब कल्याण योजना.",
    benefit3Title: "कौशल्य विकास व प्रशिक्षण",
    benefit3Desc:
      "एमएमएमओसीएल मेट्रो अकादमी येथे आधुनिक प्रशिक्षण आणि पदोन्नतीची सुस्पष्ट संधी.",
    benefit4Title: "जनसेवेचा अभिमान",
    benefit4Desc:
      "शहरातील वाहतूक कोंडी कमी करून पर्यावरणाचे रक्षण करणे आणि लाखो प्रवाशांची सेवा करणे.",

    howToTitle: "अर्ज करण्याची सोपी प्रक्रिया",
    howToSubtitle: "मेट्रो करिअर सुरू करण्यासाठी फक्त तीन पायऱ्या.",
    step1Title: "१. प्रोफाईल तयार करा",
    step1Desc: "आपली शैक्षणिक माहिती आणि आवश्यक कागदपत्रांसह उमेदवार खाते नोंदणीकृत करा.",
    step2Title: "२. पदे शोधा व अर्ज करा",
    step2Desc: "विभागांनुसार रिक्त जागा तपासा, वयोमर्यादा पहा आणि ऑनलाईन अर्ज सादर करा.",
    step3Title: "३. स्थिती ट्रॅक करा",
    step3Desc: "शॉर्टलिस्टिंग, लेखी परीक्षा आणि मुलाखतीचे वेळापत्रक थेट आपल्या खात्यावर तपासा.",

    noJobsTitle: "शोध परिणामांनुसार पदे आढळली नाहीत",
    noJobsDesc: "कृपया शोध शब्द बदला किंवा सर्व पदे पाहण्यासाठी फिल्टर रीसेट करा.",
    applyBy: "अंतिम मुदत",
    postedOn: "प्रसिद्ध दिनांक",
    viewDetails: "तपशील पहा",
    applyNow: "अर्ज करा",
    alreadyApplied: "अर्ज केला आहे",
    closingSoonTag: "मुदत लवकरच संपेल",
    newTag: "नवीन",
    activelyHiring: "भरती सुरू",

    paginationPrevious: "मागील",
    paginationNext: "पुढील",
    paginationPageOf: "पृष्ठ {current} पैकी {total}",
    itemsPerPage: "प्रति पृष्ठ संख्या",

    alertsTitle: "नवीन भरती सूचना मिळवा",
    alertsDesc: "नवीन पदांची जाहिरात प्रसिद्ध झाल्यावर तात्काळ ईमेल सूचना मिळवण्यासाठी नोंदणी करा.",
    alertsPlaceholder: "आपला ईमेल पत्ता प्रविष्ट करा",
    alertsSubscribeBtn: "सदस्यता घ्या",
    alertsSuccess: "भरती सूचनांसाठी आपली नोंदणी यशस्वी झाली आहे!",
  },
  jobDetails: {
    backToOpenings: "सर्व रिक्त पदांकडे परत जा",
    breadcrumbHome: "मुख्यपृष्ठ",
    breadcrumbOpenings: "रिक्त पदे",
    deptLabel: "विभाग",
    typeLabel: "रोजगाराचा प्रकार",
    locationLabel: "ठिकाण",
    salaryLabel: "वेतनश्रेणी",
    deadlineLabel: "अर्ज करण्याची शेवटची तारीख",
    ageLabel: "वयोमर्यादा",
    notSpecified: "नमूद नाही",
    asPerNorms: "शासकीय नियमांनुसार",

    overviewHeading: "पदाचा संक्षिप्त परिचय",
    responsibilitiesHeading: "मुख्य जबाबदाऱ्या व कार्ये",
    qualificationsHeading: "पात्रता व शैक्षणिक निकष",
    skillsHeading: "अपेक्षित कौशल्ये",
    selectionHeading: "निवड प्रक्रिया",
    benefitsHeading: "कर्मचारी लाभ व भत्ते",

    defaultBenefits: [
      "शासकीय नियमांनुसार वेतनश्रेणी व भत्ते (DA, HRA)",
      "सर्वसमावेशक आरोग्य व वैद्यकीय विमा",
      "भविष्य निर्वाह निधी (PF), उपदान आणि निवृत्ती वेतन लाभ",
      "मेट्रो मोफत प्रवास पास आणि पाळी कामकाज भत्ते",
      "एमएमएमओसीएल अकादमीमध्ये विशेष तांत्रिक प्रशिक्षण",
      "कामातील गुणवत्तेनुसार पदोन्नतीची संधी",
    ],
    defaultStages: [
      "ऑनलाईन अर्जांची छाननी",
      "लेखी परीक्षा / तांत्रिक चाचणी",
      "मूळ कागदपत्र पडताळणी व वैद्यकीय तपासणी",
      "वैयक्तिक मुलाखत व अंतिम निवड",
    ],

    stickyTitle: "या पदासाठी अर्ज करू इच्छिता?",
    applyForJob: "या पदासाठी अर्ज करा",
    alreadyAppliedBtn: "अर्ज सादर केला आहे",
    loginToApply: "अर्ज करण्यासाठी लॉगिन करा",
    deadlinePassed: "मुदत संपली आहे",
    shareTitle: "शेअर करा",
    shareCopied: "लिंक क्लिपबोर्डवर कॉपी केली!",
  },
  apply: {
    pageTitle: "नोकरीसाठी अर्ज",
    pageSubtitle: "{title} या पदासाठी अर्ज सादर करा",
    backToJob: "पदाच्या जाहिरातीकडे परत जा",
    applicantSnapshot: "उमेदवाराची माहिती (आपल्या प्रोफाईलवरून)",
    fullName: "पूर्ण नाव",
    email: "ईमेल पत्ता",
    mobile: "मोबाईल क्रमांक",
    experience: "एकूण अनुभव",
    currentCtc: "सध्याचे वेतन (CTC)",
    expectedCtc: "अपेक्षित वेतन (CTC)",
    editProfileHint: "आपली संपर्क किंवा शैक्षणिक माहिती बदलण्यासाठी प्रोफाईल संपादित करा.",

    resumeHeading: "बायोडाटा / रिझ्युमे (Resume)",
    resumeOnFile: "प्रोफाईलमधील रिझ्युमे उपलब्ध आहे",
    replaceResume: "दुसरा रिझ्युमे अपलोड करा",
    keepExisting: "प्रोफाईलमधील रिझ्युमे वापरा",
    uploadResume: "नवीन रिझ्युमे अपलोड करा (PDF, DOCX कमाल ५ MB)",

    coverLetterHeading: "कव्हर लेटर / मनोगत (ऐच्छिक)",
    coverLetterPlaceholder:
      "या पदासाठी आपण योग्य का आहात, आपला संबंधित मेट्रो/रेल्वे अनुभव आणि ठळक कामगिरी थोडक्यात नमूद करा...",

    additionalHeading: "अतिरिक्त माहिती व लिंक्स",
    portfolioUrl: "कामाचे नमुने / पोर्टफोलिओ लिंक (URL)",
    linkedinUrl: "लिंक्डइन प्रोफाईल लिंक (URL)",
    noticePeriod: "नोटीस कालावधी (Notice Period)",
    noticePeriodSelect: "कालावधी निवडा",
    noticeImmediate: "तात्काळ रुजू होऊ शकता",
    notice15Days: "१५ दिवस किंवा कमी",
    notice30Days: "१ महिना (३० दिवस)",
    notice60Days: "२ महिने (६० दिवस)",
    notice90Days: "३ महिने (९० दिवस)",

    declarationHeading: "प्रतिज्ञापत्र व संमती",
    declarationText:
      "मी याद्वारे घोषित करतो/करते की या अर्जात दिलेली सर्व माहिती माझ्या संपूर्ण माहितीनुसार सत्य व बिनचूक आहे. कोणतीही माहिती खोटी किंवा चुकीची आढळल्यास माझी उमेदवारी तात्काळ रद्द केली जाईल याची मला पूर्ण जाणीव आहे.",

    submitApplication: "अर्ज सादर करा",
    submitting: "सादर होत आहे...",
    cancel: "रद्द करा",

    successTitle: "अर्ज यशस्वीरित्या सादर झाला!",
    alreadyAppliedTitle: "आपण यापूर्वीच अर्ज केला आहे",
    successMsg:
      "{title} या पदासाठी अर्ज केल्याबद्दल धन्यवाद. आपला संदर्भ क्रमांक {ref} असा आहे. आमची भरती समिती आपल्या पात्रतेची पडताळणी करेल.",
    alreadyAppliedMsg:
      "आपण या पदासाठी आधीच अर्ज सादर केला आहे. आपण आपल्या प्रोफाईल पानावर अर्जाची सद्यस्थिती आणि मुलाखतीचे अपडेट तपासू शकता.",
    viewProfileBtn: "माझे अर्ज पहा",
    backHomeBtn: "इतर रिक्त पदे पहा",
  },
  auth: {
    loginTitle: "उमेदवार लॉगिन",
    loginSubtitle: "अर्जाची स्थिती तपासा, मुलाखतीचे वेळापत्रक पहा आणि प्रोफाईल व्यवस्थापित करा.",
    emailOrMobile: "ईमेल किंवा मोबाईल क्रमांक",
    password: "पासवर्ड",
    rememberMe: "लक्षात ठेवा",
    forgotPassword: "पासवर्ड विसरलात?",
    signInBtn: "लॉगिन करा",
    noAccount: "खाते नाही का?",
    registerHere: "येथे नवीन नोंदणी करा",

    registerTitle: "नवीन उमेदवार नोंदणी",
    registerSubtitle: "एमएमएमओसीएल भरतीसाठी आपले उमेदवार प्रोफाईल तयार करा.",
    hasAccount: "आधीच खाते आहे का?",
    signInLink: "येथे लॉगिन करा",

    stepAccount: "खाते",
    stepContact: "संपर्क",
    stepEducation: "शिक्षण",
    stepExperience: "अनुभव",
    stepDocuments: "कागदपत्रे",

    step1Title: "खात्याचा तपशील",
    fullNameLabel: "पूर्ण नाव (आधार कार्डानुसार)",
    mobileLabel: "१० अंकी मोबाईल क्रमांक",
    emailLabel: "ईमेल पत्ता",
    dobLabel: "जन्मतारीख",
    passwordLabel: "पासवर्ड तयार करा",
    confirmPasswordLabel: "पासवर्ड पुन्हा प्रविष्ट करा",
    passwordHint: "किमान ८ अक्षरांचा असावा.",

    step2Title: "निवासी संपर्क पत्ता",
    addressLabel: "संपूर्ण पत्ता",
    cityLabel: "शहर / जिल्हा",
    stateLabel: "राज्य",
    pinLabel: "पिन कोड (६ अंक)",

    step3Title: "शैक्षणिक पात्रता",
    qualificationLabel: "उच्चतम शैक्षणिक पात्रता",
    selectQualification: "पात्रता निवडा",
    universityLabel: "विद्यापीठ / मंडळ / संस्था",
    passingYearLabel: "उत्तीर्ण वर्ष (YYYY)",
    percentageLabel: "टक्केवारी / CGPA",

    step4Title: "कामाचा अनुभव",
    candidateTypeLabel: "उमेदवाराचा प्रकार",
    typeFresher: "नवशिका (Fresher)",
    typeExperienced: "अनुभवी (Experienced)",
    employerLabel: "सध्याची / मागील संस्था/कंपनी",
    totalExpLabel: "एकूण अनुभव (वर्षे/महिने)",
    relevantExpLabel: "संबंधित मेट्रो/वाहतूक क्षेत्रातील अनुभव",
    currentCtcLabel: "सध्याचे वार्षिक वेतन (₹ CTC)",
    expectedCtcLabel: "अपेक्षित वार्षिक वेतन (₹ CTC)",

    step5Title: "कागदपत्रे अपलोड करा",
    uploadResumeLabel: "बायोडाटा / रिझ्युमे (PDF, कमाल ५ MB)",
    uploadPhotoLabel: "पासपोर्ट आकाराचे छायाचित्र (JPG/PNG, कमाल २ MB)",
    uploadAadhaarLabel: "आधार कार्ड प्रत (PDF/JPG, कमाल ५ MB)",
    uploadPanLabel: "पॅन कार्ड प्रत (ऐच्छिक, PDF/JPG)",
    uploadCertificatesLabel: "शैक्षणिक प्रमाणपत्रे (PDF, कमाल १० MB)",
    termsAgreement:
      "मी भरती नियमांशी सहमत आहे आणि जाहीर करतो/करते की सादर केलेली सर्व कागदपत्रे खरी व प्रमाणित आहेत.",

    nextBtn: "पुढे जा",
    prevBtn: "मागे जा",
    finishRegistration: "नोंदणी पूर्ण करा",
    registering: "खाते तयार होत आहे...",

    registrationCompleteTitle: "नोंदणी यशस्वी झाली!",
    registrationCompleteMsg:
      "आपले उमेदवार प्रोफाईल तयार झाले आहे. आता आपण विविध पदांसाठी थेट ऑनलाईन अर्ज करू शकता.",
    proceedToLogin: "लॉगिन करण्यासाठी पुढे जा",

    forgotTitle: "पासवर्ड रीसेट करा",
    forgotSubtitle: "आपला नोंदणीकृत ईमेल पत्ता प्रविष्ट करा, आम्ही पासवर्ड रीसेट लिंक पाठवू.",
    sendResetLink: "रीसेट लिंक पाठवा",
    backToLogin: "लॉगिनकडे परत जा",
  },
  profile: {
    pageTitle: "उमेदवार प्रोफाईल व अर्ज",
    pageSubtitle: "आपली माहिती आणि भरती अर्जांची सद्यस्थिती व्यवस्थापित करा.",
    tabApplications: "माझे अर्ज",
    tabProfile: "वैयक्तिक माहिती",

    noApplicationsTitle: "अद्याप कोणताही अर्ज सादर केलेला नाही",
    noApplicationsDesc: "आपण अद्याप कोणत्याही पदासाठी अर्ज केलेला नाही. उपलब्ध पदे पाहून त्वरित अर्ज करा.",
    browseJobsBtn: "उपलब्ध पदे पहा",

    appRef: "संदर्भ क्रमांक",
    appRole: "पद",
    appDept: "विभाग",
    appDate: "अर्जाचा दिनांक",
    appStatus: "स्थिती",
    appActions: "तपशील",

    interviewScheduledAlert: "मुलाखत निश्चित झाली आहे!",
    interviewDate: "दिनांक व वेळ",
    interviewType: "मुलाखतीचे माध्यम",
    interviewVenue: "स्थान / लिंक",
    interviewNotes: "महत्त्वाच्या सूचना",
    virtualMode: "ऑनलाईन / आभासी",
    onsiteMode: "प्रत्यक्ष उपस्थिती / ऑनसाइट",
  },
  common: {
    loading: "लोड होत आहे...",
    error: "काहीतरी चूक झाली. कृपया पुन्हा प्रयत्न करा.",
    tryAgain: "पुन्हा प्रयत्न करा",
    permanent: "कायमस्वरूपी",
    contract: "कंत्राटी",
    temporary: "तात्पुरते",
    perYear: "वर्ष",
    perMonth: "महिना",
    perDay: "दिवस",
    perHour: "तास",
    years: "वर्षे",
    upTo: "जास्तीत जास्त",
    yearsOld: "वर्षे",
    statusApplied: "अर्ज सादर केला",
    statusUnderReview: "तपासणी सुरू",
    statusShortlisted: "शॉर्टलिस्ट केले",
    statusInterviewScheduled: "मुलाखत निश्चित केली",
    statusInterviewed: "मुलाखत पूर्ण",
    statusRejected: "निवड झाली नाही",
    statusHired: "निवड झाली",
    statusSelected: "निवड झाली",
  },
};
